import type { ListBuilderList } from '../../../types';

/**
 * Expired list - licenses that have lapsed and need renewal action.
 *
 * Sorted by most recently expired first so compliance officers can
 * prioritize clients that just fell out of compliance.
 */
export const expiredList: ListBuilderList = {
	id: 'default-licenses-expired',
	cacheTTL: 300000,
	name: 'Expired',
	type: 'default',
	active: true,
	sortOrder: 3,
	filterRules: {
		licenseStatus: {
			defaultValue: [{ id: 'Expired', label: 'Expired' }],
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	defaultSortId: 'column-license-expiration-desc',
	inheritsFrom: 'default-licenses-all',
};
